export default __webpack_public_path__ + "assets/icon-toggle-off.a882252d.webp";